<div *ngIf="files.length" class="fixed-top-bar flex flex-row items-center justify-between">
  <div class="flex flex-1 flex-row items-center gap-5">
    <input
      type="text"
      [value]="printProduct.product.folderName"
      [(ngModel)]="printProduct.product.folderName"
      (focusout)="checkFolderName($event)"
      class="group-name-input"
    />
    <app-print-settings-labels
      [printSettings]="printProduct.product.printingGroup.printSettings"
      [files]="printingGroupFiles"
    >
    </app-print-settings-labels>
  </div>
  <div class="flex flex-row items-center gap-5">
    <app-upload-files-options [fromBar]="true" [printProduct]="printProduct" [files]="files"></app-upload-files-options>
  </div>
</div>
